import React from 'react';
import { getSuggestions } from '../services/address.api';
import Autosuggest from 'react-autosuggest';
import { Address } from '../services/models/address';
import { deBounce } from '../utils';

interface Props {
  onSelect: Function;
  onUnSelect: Function;
  value: string;
  hasError?: boolean;
}

interface State {
  value: string;
  suggestions: string[] | Address[];
  disabled: boolean;
}

export const withWrapperAutoSuggest = (
  contentType: string = 'address',
  placeholder: string = 'Start typing...',
  filterByCity: string = '',
  filterBySuburb: string = '',
) => {
  const getSuggestionValue = suggestion =>
    contentType === 'address' ? suggestion.label : suggestion;
  const renderSuggestion = suggestion => (
    <div>{contentType === 'address' ? suggestion.label : suggestion}</div>
  );

  return class extends React.Component<Props, State> {
    constructor(props: Props) {
      super(props);
      this.state = {
        value: props.value || '',
        suggestions: [],
        disabled: !!props.value,
      };
    }

    onChange = (event, { newValue }) => {
      this.setState({
        value: newValue,
      });
    };

    onSuggestionsFetchRequested = deBounce(({ value }) => {
      getSuggestions(contentType, value, filterByCity, filterBySuburb).then(
        suggestions => {
          let requiredSuggestions: string[] | Address[] = [];
          if (contentType === 'suburb' || contentType === 'postcode') {
            suggestions.forEach(suggestion => {
              if (
                suggestion[contentType] &&
                !requiredSuggestions.find(
                  ele => ele === suggestion[contentType],
                )
              ) {
                requiredSuggestions.push(suggestion[contentType]);
              }
            });
          } else {
            requiredSuggestions = [...suggestions];
          }
          if (contentType === 'address') {
            if (
              (value || '').length > 3 &&
              (requiredSuggestions || []).length === 0
            ) {
              requiredSuggestions = [
                {
                  address_id: undefined,
                  label: 'No relevant suggestions? Click here to input manually.',
                },
              ];
            }
          }
          this.setState({
            suggestions: requiredSuggestions,
          });
        },
      );
    },500);

    onSuggestionsClearRequested = () => {
      this.setState({
        suggestions: [],
      });
    };

    onSuggestionSelected = (event, { suggestion }) => {
      this.props.onSelect(suggestion);
      this.setState({ disabled: true });
    };

    clearSelection = () => {
      this.props.onUnSelect();
      this.setState({ value: '', disabled: false });
    };

    renderInputComponent = inputProps => {
      return (
        <div
          className={`inputContainer form-control ${
            !!this.props.hasError ? 'is-invalid' : ''
          }`}
        >
          <input {...inputProps} placeholder={placeholder} />
          <div
            className="cross"
            style={{ display: this.state.disabled ? 'block' : 'none' }}
            onClick={this.clearSelection}
          />
        </div>
      );
    };

    render() {
      const { value, suggestions } = this.state;

      const inputProps = {
        placeholder: '',
        value,
        onChange: this.onChange,
        autoComplete: 'disable',
        disabled: this.state.disabled,
      };

      return (
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          onSuggestionSelected={this.onSuggestionSelected}
          renderSuggestion={renderSuggestion}
          renderInputComponent={this.renderInputComponent}
          inputProps={inputProps}
        />
      );
    }
  };
};
